import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import { FormControl } from 'material-ui/Form';
import Input, { InputLabel } from 'material-ui/Input';
import Grid from 'material-ui/Grid';
import { CircularProgress } from 'material-ui/Progress';
import PropertyItem from './components/PropertyItem';
import ContinueButton from '../../common/components/Buttons/ContinueButton';
import SectionTitle from '../../common/components/Typography/SectionTitle';

const styles = ({ spacing: { unit } }) => ({
    root: {
        width: '100%',
        marginLeft: '16px',
    },
    button: {
        marginLeft: unit * 2,
        '&:first-child': {
            marginLeft: 0,
        },
    },
    buttons: {
        marginTop: unit * 2,
        marginBottom: unit * 2,
    },
    formControl: {
        marginTop: unit * 3,
        minWidth: unit * 20,
        maxWidth: unit * 43,
        width: '100%',
        '&:not(:last-of-type)': {
            marginRight: unit * 3,
        },
    },
    grid: {
        marginTop: 0,
    },
});

function PropertyDetails(props) {
    const goToNextStep = () => {
        const {
            applicationType,
            applicantsIncome,
            mortgageType,
            estaminatedPropertyValue,
            estaminatedPropertyMonthlyRent,
            requestedLoanAmount,
            requestedTimeSpan,
            customer,
        } = props;
        const params = {
            applicationType,
            applicants: applicantsIncome.length,
            applicantsIncome,
            mortgageType,
            requestedLoanAmount,
            estaminatedPropertyValue,
            estaminatedPropertyMonthlyRent,
            requestedTimeSpan,
            customer,
        };
        props.setStep(8);
        props.setStepCompleted(7, true);
        props.getBestOffers(params);
    };

    const propertyList = props.propertyList.map(property => (
        <Grid
            item
            xs={12}
            sm={4}
            key={property.propertyId}
        >
            <PropertyItem
                property={property}
                selectProperty={props.selectProperty}
                selectedProperty={props.selectedProperty}
            />
        </Grid>
    ));
    return (
        <div className={props.classes.root}>
            <div>
                <div>
                    <FormControl
                        className={props.classes.formControl}
                    >
                        <InputLabel htmlFor="propertyAddress">
                            Search your address
                        </InputLabel>
                        <Input
                            id="propertyAddress"
                            value={props.searchedAddress}
                            onChange={(event) => {
                                props.setSearchedAddress(event);
                                // setStepUncompleted();
                            }}
                        />
                    </FormControl>
                    <Button
                        className={props.classes.button}
                        variant="raised"
                        color="primary"
                        onClick={() => {
                            props.doSearch();
                        }}
                    >
                        Search
                    </Button>
                </div>
                <div>
                    {props.searchInProgress &&
                    <CircularProgress />
                    }
                    {!props.searchInProgress && props.propertyList.length > 0 &&
                        <div>
                            <div className={props.classes.sectionTitle}>
                                <SectionTitle>
                                    Products list
                                </SectionTitle>
                            </div>
                            <Grid
                                className={props.classes.grid}
                                container
                                spacing={24}
                            >
                                {propertyList}
                            </Grid>
                        </div>
                    }
                </div>
            </div>
            <div className={props.classes.buttons}>
                <Button
                    className={props.classes.button}
                    color="default"
                    onClick={() => {
                        props.setStep(6);
                        props.setStepCompleted(7, false);
                    }}
                >
                    Back
                </Button>
                <ContinueButton
                    className={props.classes.button}
                    disabled={!props.selectedProperty.propertyId}
                    onClick={() => {
                        goToNextStep();
                    }}
                />
            </div>
        </div>
    );
}

PropertyDetails.propTypes = {
    setStep: PropTypes.func.isRequired,
    setStepCompleted: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    searchedAddress: PropTypes.string.isRequired,
    setSearchedAddress: PropTypes.func.isRequired,
    doSearch: PropTypes.func.isRequired,
    propertyList: PropTypes.array.isRequired,
    searchInProgress: PropTypes.bool.isRequired,
    selectProperty: PropTypes.func.isRequired,
    selectedProperty: PropTypes.object.isRequired,
    getBestOffers: PropTypes.func.isRequired,
    applicationType: PropTypes.string.isRequired,
    mortgageType: PropTypes.string.isRequired,
    applicantsIncome: PropTypes.array.isRequired,
    estaminatedPropertyValue: PropTypes.object.isRequired,
    estaminatedPropertyMonthlyRent: PropTypes.object.isRequired,
    requestedLoanAmount: PropTypes.object.isRequired,
    requestedTimeSpan: PropTypes.number.isRequired,
    customer: PropTypes.object.isRequired,
};

export default withStyles(styles)(PropertyDetails);



// WEBPACK FOOTER //
// ./src/app/FormStepper/PropertyDetails/PropertyDetails.js